import React from 'react'
import { useRouter } from 'next/router';
import { useQuery } from 'react-query';

/**
 * Internal dependencies
 */
import { fetchAPI, getLocale } from 'utils';
import Articles from 'components/articles/articles';
import Layout from 'layout/layout';
import SEO from 'components/seo/seo';
import HreflangControlled from 'blocks/hreflang/hreflang-controlled';
import BlogIntro from 'components/blog-intro/blog-intro';

interface BlogProps {
  prop: {
    articles: any;
    locales: any;
    locale: string;
    data: any;
    articleTags?: any;
  }
  hreflangs: any;
  filter?: boolean;
}

const BlogLogic = ({prop,hreflangs, filter}: BlogProps) => {
  const router = useRouter();
  const seoData = prop.data.data?.attributes.SEO ?? null;
  const introTitle = prop.data?.data?.attributes.IntroTitle ?? "";
  const articleTags = prop.articleTags?.data ?? [];
  const currentPage = router.query.page || 1;

  const { isLoading, data } = useQuery(["articles", currentPage], async () => {
    let payload: any = {
      populate: "*",
      locale: getLocale(prop.locale),
      pagination: {
        page: currentPage,
        pageSize: 18,
      },
    }

    if(filter) {
      payload.filters = {
        article_tags: {
          slug: router.query.slug,
        },
      }
    }

    const data = await fetchAPI("/articles", payload);
    return data;
  });

  const handleArticles = () => {
    if(currentPage === 1) {
      return <Articles articles={prop.articles} pagination={true} />;
    } else if(!isLoading) {
      return <Articles articles={data} pagination={true} />;
    }
    
    return null;
  }

  return (
    <Layout
      title="Blog"
      desc="DigiFist"
      light={false}
      dark={false}
      FooterAlt={true}
      notice
      hreflang={false}
    >
      <SEO data={seoData} />
      <HreflangControlled localizations={hreflangs} />

      <BlogIntro title={introTitle} tags={articleTags} />

      {handleArticles()}
    </Layout>
  )
}

export default BlogLogic